import { render, staticRenderFns } from "./MenuNewApplication.vue?vue&type=template&id=e087f460&scoped=true&"
import script from "./MenuNewApplication.vue?vue&type=script&lang=js&"
export * from "./MenuNewApplication.vue?vue&type=script&lang=js&"
import style0 from "./MenuNewApplication.vue?vue&type=style&index=0&id=e087f460&scoped=true&lang=css&"
import style1 from "./MenuNewApplication.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e087f460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
